import { Box, Flex } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import { ShimmerCss, IconButtonCss, Tags2Css } from './styles'
import { AvatarShimmer } from 'components/shimmers/avatar'
import { TextShimmer } from './text'

export const UserShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <AvatarShimmer
          showToggle={true}
          showIcon={true}
          iconStyle="rounded"
          iconSize="md"
        />
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
      <TableTd align={'center'}>
        <Flex justify={'end'}>
          <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
        </Flex>
      </TableTd>
    </TableItemRow>
  )
}
